import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "flowbite";

// Admin Pages
import Starter from "./Admin/Pages/Index.jsx";
import Login from "./loginpage.jsx";

import Index from "./Admin/Pages/Index.jsx";

import Notfound from "./Notfound.jsx";
import Client from "./Admin/Pages/Client.jsx";
import Project from "./Admin/Pages/Project.jsx";
import Ledger from "./Admin/Pages/Ledger.jsx";
import Edit_project from "./Admin/components/Edit_project.jsx";
import Project_view from "./Admin/components/Project_view.jsx";
import Website from "./Admin/Pages/Website.jsx";
import Ledger_Due from "./Admin/Pages/Ledger_Due.jsx";
import Add_Project_ledger from "./Admin/components/Add_Project_ledger.jsx";
import Edit_project_ledger from "./Admin/components/Edit_project_ledger.jsx";
import Report from "./Admin/Pages/Report.jsx";
 

// // User Pages

// Helper function to check if the user is logged in
const isAuthenticated = () => {
  // Check if the user has a valid authToken in localStorage
  return (
    !!localStorage.getItem("authToken") && !!localStorage.getItem("userId")
  );
};

// Protected Route Component for Admin
const ProtectedRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to='/' />;
};


function App() {
  return (
    <div className='app'>
      <Router>
        <Routes>
          {/* Admin Routes */}
          <Route path='/' element={<Login />} />
          <Route
            path='/dashboard'
            element={<ProtectedRoute element={<Index />} />}
          />
          <Route
            path='/dashboard/client'
            element={<ProtectedRoute element={<Client />} />}
          />
          <Route
            path='/dashboard/project'
            element={<ProtectedRoute element={<Project />} />}
          />
          <Route
            path='/dashboard/ledger'
            element={<ProtectedRoute element={<Ledger />} />}
          />

          <Route
            path='/dashboard/edit-project/:id'
            element={<ProtectedRoute element={<Edit_project />} />}
          />
          <Route
            path='/dashboard/edit-ledger/:id'
            element={<ProtectedRoute element={<Edit_project_ledger />} />}
          />
          <Route
            path='/dashboard/add-ledger/:project_id?/:client_id?/:parent_id?'
            element={<ProtectedRoute element={<Add_Project_ledger />} />}
          />
          <Route
            path='/dashboard/view-project/:id'
            element={<ProtectedRoute element={<Project_view />} />}
          />
          <Route
            path='/dashboard/website'
            element={<ProtectedRoute element={<Website />} />}
          />
          <Route
            path='/dashboard/ledger-due'
            element={<ProtectedRoute element={<Ledger_Due />} />}
          />

          <Route
            path='/dashboard/report'
            element={<ProtectedRoute element={<Report />} />}
          />


          {/* Admin */}
          <Route path='*' element={<Notfound />} />
          {/* User Routes */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
